<template>
  <div class="calendar-box b-box">
    <div class="innner">
      <div class="intro">
        <div class="title">考试日历</div>
        <div class="info">对标往届成绩线，距离一目了然</div>
      </div>
      <el-calendar locale="zh-cn">
        <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
        <template slot="dateCell" slot-scope="{ date, data }">
          <p class="dateitem" :class="data.isSelected ? 'is-selected' : ''">
            {{
              data.day
                .split('-')
                .slice(2)
                .join('-')
            }}
          </p>
          <div class="lists">
            <div
              v-for="(item, index) in dealMyDate(data.day)"
              :key="index"
              class="list"
            >
              <span v-text="item.time" /> <span v-text="item.company" />
            </div>
          </div>
        </template>
      </el-calendar>
    </div>
  </div>
</template>

<script>
import { LOGIN_API } from "@/api.js";
import moment from 'moment'
import Calendar from 'vue-calendar-component'
export default {
  data() {
    return {
      value: new Date(),
      actionMode: 0,
      dialogForm: {
        time: '',
        name: ''
      },
      dialogTitle: '',
      dialogVisible: false,

      timeRangedialogVisible: false,
      timeRange: ['2020-08-01', '2020-08-08'],

      listLoading: false,
      list: [],
      category: 9,
      range: {
        from: '2020-08-01',
        to: '2020-09-01'
      },
      categoryid: ''
    }
  },
  mounted() {
    this.loadConfig()
    window.scrollTo(0, 0)
  },
  methods: {
    submitTimeRangeHandler() {
      this.range = {
        from: moment(this.timeRange[0]).format('YYYY-MM-DD'),
        to: moment(this.timeRange[1]).format('YYYY-MM-DD')
      }
      this.saveHandler()
      this.timeRangedialogVisible = false
    },
    timeRangedialogClose() {
      this.timeRangedialogVisible = false
    },
    setTimeRangeHandler() {
      this.timeRangedialogVisible = true
    },
    dealMyDate(v) {
      //按时间排序
      return this.list
        .filter(item => item.date == v)
        .sort(function(a, b) {
          return b.time < a.time ? 1 : -1
        })
    },
    handleClose() {
      this.dialogVisible = false
    },
    loadConfig() {
      let post = {
        category: 9
      }
      this.$axios
        .post(`${LOGIN_API}/customer/api/config`, post)
        .then(res => {
          if (res.data.errno == 0) {
            if (res.data.result && res.data.result.length > 0) {
              const result = res.data.result
              this.listLoading = false
              if (result.length > 0) {
                const re = result[0].data || { list: [], range: {} }
                this.list = re.list
                this.range = re.range
                this.categoryid = result[0]._id
                this.timeRange = [
                  moment(this.range.from).format('YYYY-MM-DD'),
                  moment(this.range.to).format('YYYY-MM-DD')
                ]
              }
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar-box {
  font-weight: 300;
  cursor: auto !important;
  .innner {
    width: 1200px;
    margin: 0px auto 0px;
    padding: 20px 0px;
    .intro {
      text-align: center;
      padding: 0px 0px 20px;
      .title {
        font-size: 36px;
      }
      .info {
        font-size: 16px;
        padding: 20px;
      }
    }
  }
}
.b-box {
  background: #f7f8fd url('/static/images/bbg.png') repeat-x;
}

.boxer {
  padding: 20px;
}
.is-selected {
  color: #29bdb9;
}
.lists {
  margin-top: 24px;
  margin-left: -8px;
  margin-right: -8px;
  font-size: 12px;
  height: 100%;
  display: block;
  height: 120px;
  overflow: auto;
  .list {
    padding: 0px 10px 0px 0px;
    background: #cdeae4;
    color: #333;
    margin-bottom: 3px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .fr {
      float: right;
      padding-top: 4px;
    }
  }
  .list:before {
    content: '';
    display: inline-block;
    vertical-align: middle;
    width: 3px;
    height: 20px;
    margin-right: 3px;
    background: #ff9a9a;
  }
  .add-box {
    display: none;
    background: #ccc;
    text-align: center;
    color: #333;
    padding: 6px 0px 3px;
  }
}
.lists:hover .add-box {
  display: block;
}
</style>
<style lang="scss">
.el-calendar {
  width: 1000px;
  margin: auto;

  .el-calendar__header {
    background-color: rgba($color: #29bdb9, $alpha: 0.1);
    padding: 20px;
    .el-calendar__title {
      color: #29bdb9;
      margin-left: 70px;
      font-size: 24px;
    }
    .el-button-group {
      .el-button {
        color: #29bdb9 !important;
        background-color: transparent;
        border-color: #29bdb9;
        padding: 12px 22px;
        font-size: 14px;
        font-weight: 350;
        &:hover,
        &:visited {
          background-color: rgba($color: #29bdb9, $alpha: 0.2);
        }
      }
    }
  }
  .el-calendar__body {
    font-size: 14px;
    border: 1px solid #29bdb9;
    padding: 12px 0 35px;

    .el-calendar-table .is-today .el-calendar-day {
      border: 2px solid #29bdb9;
      background: url('~@/static/images/today.png') no-repeat left top;
    }
    .el-calendar-table .el-calendar-day {
      cursor: auto !important;
      height: initial;
    }
  }

  .el-calendar-table td {
    position: relative;
  }
  .el-calendar-table th {
    position: relative;
    font-weight: 340;
  }

  .dateitem {
    margin: 0px;
    float: right;
  }
  .calendar-box .el-calendar-table .el-calendar-day {
    height: initial;
    min-height: 84px;
  }

  .calendar-box .el-calendar-table td.is-today {
    color: #29bdb9;
  }
  .calendar-box .el-button:focus,
  .calendar-box .el-button:hover {
    color: #29bdb9;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/calendar/index.vue